import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_12: FaireProductEntity = {
  token: "atc_toast_12",
  type: "product",
  name: "Woven Seagrass Basket",
  brandName: "Olli Ella",
  imageUrl: "",
  priceDollars: 28.0,
  msrpDollars: 56.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
